module.exports = __webpack_public_path__ + "media/images/img_service_partner-4820c5ff0ed1a1b322d669fc17aea9f8.png";